module.exports = __webpack_public_path__ + "img/avatar_ico10.be9f153b.jpg";